<template>
    <div class="deck-card-partner" @click.self="viewCards">
        <div class="deck-card-partner__image" @click="viewCards">
            <img class="img-fluid" :src="cardDeck.central_image"/>
            <partner-badge :floating="true"></partner-badge>
        </div>
        <div class="d-flex flex-row w-100 align-items-center justify-content-between" style="margin-top: 12px;">
            <div class="deck-card-partner__logo-card">
                <img v-if="cardDeck.corporateBrand && cardDeck.corporateBrand.logo" height="40" :src="cardDeck.corporateBrand.logo">
            </div>
            <avatar-group v-if="!communityCard && cardDeck.assigned_heroes.length"
                          size="xs"
                          :users="cardDeck.assigned_heroes"
                          @addToMagnusCards="$emit('onAssignCardDeck')">
            </avatar-group>
        </div>
        <div class="flex-1 w-100" @click="viewCards">
            <div class="deck-card-partner__title mt-2">
                {{ cardDeck.title }}
            </div>
            <div class="d-flex flex-row w-100 justify-content-between mt-2">
                <div class="d-flex gap-1">
                    <span v-if="cardDeck.category" class="deck-card-partner__category-label">{{cardDeck.category ? cardDeck.category.label : ''}}</span>
                    <span class="deck-card-partner__category-label cards-counter">
                        {{ cardDeck.cards.length }} {{ cardDeck.cards.length === 1 ? 'card' : 'cards'}}
                    </span>
                </div>
            </div>
        </div>
        <div v-if="!hideButtons" class="d-flex flex-column justify-content-end w-100 mt-2">
            <div v-if="communityCard" class="d-flex flex-row gap-1">
                <btn class="btn-primary flex-1" @click="addToMyCardDecks">
                    <inline-svg src="/assets/img/icons/file-plus-01.svg" class="me-1"></inline-svg>
                    Add to my Card Decks</btn>
                <div class="deck-card-partner__favorite" :class="{ 'selected': cardDeck.is_favorite }"
                     @click="toggleFavorite()"
                >
                    {{cardDeck.favorites_count ? cardDeck.favorites_count : '' }}
                    <inline-svg src="/assets/img/icons/heart-rounded.svg"></inline-svg>
                </div>
            </div>
            <div v-else class="d-flex flex-row gap-1">
                <btn class="btn-primary w-100"
                     style="flex: 1;"
                     @click="$emit('onAssignCardDeck')"
                >
                    Share with Heroes
                </btn>
                <tippy
                        :ref="'cardMenu'"
                        trigger="click"
                        placement="bottom"
                        :arrow="false"
                        :interactive="true"
                        theme="light"
                >
                    <div>
                        <a href="#" class="dropdown-menu__menu-item" @click.prevent="viewCards">
                            <inline-svg src="/assets/img/icons/eye.svg"></inline-svg>
                            View
                        </a>
                        <a href="#" class="dropdown-menu__menu-item" @click.prevent="editCardDeck">
                            <inline-svg src="/assets/img/icons/edit-04.svg"></inline-svg>
                            Edit
                        </a>
                        <a href="#" class="dropdown-menu__menu-item" @click.prevent="$emit('onShareCollaboration')">
                            <inline-svg src="/assets/img/icons/share-team.svg"></inline-svg>
                            Share with team
                        </a>
                        <a href="#" class="dropdown-menu__menu-item" @click.prevent="removeCardDeck">
                            <inline-svg src="/assets/img/icons/trash-01.svg"></inline-svg>
                            Remove from My Card Decks
                        </a>
                    </div>
                    <template #trigger>
                        <btn class="btn-outline-light white">
                            <inline-svg height="20" src="/assets/img/icons/dots-vertical.svg"></inline-svg>
                        </btn>
                    </template>
                </tippy>
            </div>
        </div>
    </div>
</template>

<script>

import { tippy } from "vue-tippy";
import AvatarGroup from "@/components/AvatarGroup.vue";
import PartnerBadge from "@/components/PartnerBadge.vue";

export default {
  name: 'DeckCardPartner',
  props: ['hideButtons', 'communityCard', 'cardDeck'],
  components: {PartnerBadge, AvatarGroup},
  data() {
    return {
      loading: {
        delete: false,
      },
      favorite: false,
    }
  },
  methods: {
    viewCards() {
      if (this.communityCard) {
        this.$router.push({name: 'card.deck.cards', params: {id: this.cardDeck.id}})
      } else {
        this.$refs['cardMenu'].tip.hide();
        this.$emit('onViewCards', this.cardDeck)
      }
    },
    toggleFavorite() {
      let url = "/deck/add-favorite";
      if (this.cardDeck.is_favorite) {
        url = "/deck/remove-favorite"
      }
      this.$http.post(url, {deck_id: this.cardDeck.id})
        .then((res) => {
          if (!this.cardDeck.is_favorite && localStorage.getItem("hideConfirmFavoriteCardDeckAddedModal") !== "true") {
            this.$modal.show("confirmFavoriteCardDeckAddedModal");
          }
          this.$events.emit('loadCommunityCardDecks');
        })
        .catch((error) => {
          console.log(error)
        });
    },
    addToMyCardDecks() {
      this.$http.post("/deck/add-to-deck", {deck_id: this.cardDeck.id})
        .then((res) => {
          this.$gtag.event('community_card_deck_copied', {
            deck_id: this.cardDeck.id,
            deck_title: this.cardDeck.title
          });
          this.$events.emit('loadMyCardDecks');
        })
        .catch((error) => {
          console.log(error)
        });
    },
    removeCardDeck() {
      const self = this;
      this.$dialog.confirm('Are you sure you want to remove this Card Deck from your Card Decks?', {
        okText: 'Yes',
        cancelText: 'No',
      }).then(() => {
        self.loading.delete = true;
        self.$http.post("/deck/remove-from-my-decks", {id: self.cardDeck.id, type: 'partner_deck'})
          .then(() => {
            self.$events.emit('loadMyCardDecks');
            self.loading.delete = false;
          })
          .catch(() => {
            self.loading.delete = false;
          });
      });
    },
    editCardDeck() {
      if (this.cardDeck.deck_copied) {
          this.$dialog.alert('Partner Card Decks cannot be edited!', {
              okText: 'Ok',
          });
        // this.$dialog.confirm('Please be aware that if you edit card deck taken from Community Library it will create a clone after you save the changes', {
        // })
        //   .then(() => {
        //     this.$emit('onEditCardDeck');
        //     this.$refs['cardMenu'].tip.hide();
        //   });
      }
    },
  }
};

</script>
